import { FC, ReactNode } from 'react';
import styled from 'styled-components';

export interface DataProps {
  children: ReactNode;
}

const StyledUnderlyingCode = styled.th`
  min-width: 110px;
`;

export const Data: FC<DataProps> = ({ children }) => (
  <StyledUnderlyingCode
    className="text-nowrap border align-middle py-0"
    data-e2e="selected-underlying-item-idOrWeight"
    scope="row"
  >
    <div
      className="w-100 d-flex justify-content-between flex-nowrap align-items-center px-1 text-info"
      data-e2e="selected-underlying-code"
    >
      {children}
    </div>
  </StyledUnderlyingCode>
);
